import React from "react";

export default function Container() {
  return (
    <div className="Topbar">
      <h1>Welcome to Code Clear</h1>
    </div>
  );
}
